import { useEffect, useState } from "react";
import {
  getRoles,
  assignRole,
  getRolesBatches
} from "../../services/accessControl.api";
import { useSelector } from "react-redux";

export default function AssignRoleModal({
  
  user,
  onClose
}) {

const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const AppId = useSelector((state)=>state?.app?.app?.ID);

  const [roles, setRoles] = useState([]);
  const [batches, setBatches] = useState([]);
  const [roleId, setRoleId] = useState("");
  const [scopeType, setScopeType] = useState("app");
 const [scopeId, setScopeId] = useState(AppId);

  useEffect(() => {
  
    
    loadRoles();
  }, []);
  useEffect(() => {
  
    
    loadBatches();
  }, [scopeType]);

  
  const loadRoles = async () => {
    const data = await getRoles(AppToken);
    setRoles(data);
  };

  const loadBatches = async () => {
    const data = await getRolesBatches(AppToken);
    setBatches(data);
  };

  const handleAssign = async () => {

    await assignRole({
        scopeId:scopeId,
      userId: user.ID,
      appToken:AppToken,
      scopeType,
     
      roleId
    });

    onClose();
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>

        <h3>Assign Role to {user?.firstName} {user?.lastName}</h3>

        <div>
          <label>Scope</label>
          <select
            value={scopeType}
            onChange={e => setScopeType(e.target.value)}
          >
            <option value="app">App</option>
            <option value="batch">Batch</option>
          </select>
        </div>

        <div>
          <label>Role</label>
          <select
            value={roleId}
            onChange={e => setRoleId(e.target.value)}
          >
            <option value="">Select Role</option>
            {roles
              .filter(r => r.scope_type === scopeType)
              .map(r => (
                <option key={r.id} value={r.id}>
                  {r.role_key}
                </option>
              ))}
          </select>
          {scopeType=="batch"?<select
            value={roleId}
            onChange={e => setScopeId(e.target.value)}
          >
            <option value="">Select Batch</option>
            {batches.map(r => (
                <option key={r?.batchId} value={r?.batchId}>
                  {r?.batchName}
                </option>
              ))}
          </select>:""}
        </div>

        <div style={{ marginTop: "10px" }}>
          <button onClick={onClose}>
            Cancel
          </button>
          <button onClick={handleAssign}>
            Assign
          </button>
        </div>

      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const modalStyle = {
  background: "#fff",
  padding: "20px",
  width: "300px",
  borderRadius: "6px"
};